import { useContext } from "react";
import AppThemeContext from "../context/AppTheme";

const useAppTheme = () => useContext(AppThemeContext);

export default useAppTheme;
